import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { X, Ruler } from 'lucide-react';
interface DimensionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (dimensions: string) => Promise<void>;
  orderInfo: {
    id: string;
    clientName: string;
    quantity: number;
  };
}
export function DimensionsModal({
  isOpen,
  onClose,
  onConfirm,
  orderInfo
}: DimensionsModalProps) {
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!length || !width) {
      alert('Veuillez renseigner les dimensions');
      return;
    }
    const dimensions = `${length}m x ${width}m`;
    setIsSubmitting(true);
    try {
      await onConfirm(dimensions);
      setLength('');
      setWidth('');
      onClose();
    } catch (error) {
      console.error('Failed to save dimensions', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" data-id="element-84">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-85">
        <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-blue-50" data-id="element-86">
          <div className="flex items-center" data-id="element-87">
            <Ruler className="w-5 h-5 mr-2 text-blue-600" data-id="element-88" />
            <h3 className="text-lg font-bold text-gray-900" data-id="element-89">
              Dimensions du Tapis
            </h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-90">
            <X className="w-5 h-5" data-id="element-91" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-92">
          <div className="bg-gray-50 p-3 rounded-lg text-sm mb-4" data-id="element-93">
            <div className="font-bold text-gray-900" data-id="element-94">
              {orderInfo.clientName}
            </div>
            <div className="text-gray-600" data-id="element-95">Commande: {orderInfo.id}</div>
            <div className="text-gray-600" data-id="element-96">
              Quantité: {orderInfo.quantity} tapis
            </div>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-sm text-yellow-800" data-id="element-97">
            <strong data-id="element-98">Important:</strong> Les dimensions sont obligatoires pour
            les tapis avant de terminer le nettoyage.
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-99">
            <div data-id="element-100">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-101">
                Longueur (mètres)
              </label>
              <Input type="number" step="0.1" min="0.1" value={length} onChange={e => setLength(e.target.value)} placeholder="ex: 2.5" required data-id="element-102" />
            </div>
            <div data-id="element-103">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-104">
                Largeur (mètres)
              </label>
              <Input type="number" step="0.1" min="0.1" value={width} onChange={e => setWidth(e.target.value)} placeholder="ex: 3.0" required data-id="element-105" />
            </div>
          </div>

          {length && width && <div className="bg-blue-50 p-3 rounded-lg text-center" data-id="element-106">
              <div className="text-sm text-gray-600" data-id="element-107">Dimensions</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-108">
                {length}m x {width}m
              </div>
            </div>}

          <div className="flex gap-3 pt-2" data-id="element-109">
            <Button type="button" variant="secondary" onClick={onClose} fullWidth data-id="element-110">
              Annuler
            </Button>
            <Button type="submit" fullWidth isLoading={isSubmitting} data-id="element-111">
              Confirmer
            </Button>
          </div>
        </form>
      </div>
    </div>;
}